var e={control:function(e){return delete e.outline,e}};export{e as composeStyles};
//# sourceMappingURL=utils.js.map
